import ComponentLayout from "../../../../src/layouts/component-layout";
import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { AvatarSizes, AvatarShapes } from '@primer/react-brand';
import * as React from 'react';
export default {
  ComponentLayout,
  Label,
  PropTableValues,
  AvatarSizes,
  AvatarShapes,
  React
};